import { gcApi } from 'config/axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    DISMISS_NOTIFICATION,
    DISMISS_NOTIFICATION_START,
    DISMISS_NOTIFICATION_SUCCESS,
    DISMISS_NOTIFICATION_FAIL
} from 'actions/ActionTypes';

export function* dismissNotification(action) {
    const { notificationId, dismiss } = action.payload;
    try {
        yield put({
            type: DISMISS_NOTIFICATION_START,
            notificationId
        });

        yield call(
            gcApi.put,
            `/notification-service/notification/${notificationId}/dismiss/${dismiss}`,
            action.payload
        );

        yield put({
            type: DISMISS_NOTIFICATION_SUCCESS,
            notificationId
        });
    } catch (error) {
        yield put({
            type: DISMISS_NOTIFICATION_FAIL,
            notificationId
        });
    }
}

export const notificationSagas = [takeEvery(DISMISS_NOTIFICATION, dismissNotification)];
